import { Helmet } from 'react-helmet'
import ExpandingCards from './ExpandingCards'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Expanding Cards</title>
    </Helmet>
    <ExpandingCards />
  </>
)
export default Wrapper
